var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35938 6.5625V0.453906C8.35938 0.207813 8.55078 0 8.79688 0C12.1793 0 14.9219 2.74258 14.9219 6.125C14.9219 6.37109 14.7141 6.5625 14.468 6.5625H8.35938ZM0.921875 7.4375C0.921875 4.1207 3.38555 1.37539 6.58203 0.937891C6.83359 0.902344 7.04688 1.10469 7.04688 1.35898V7.875L11.3262 12.1543C11.5094 12.3375 11.4957 12.6383 11.2852 12.7859C10.2133 13.5516 8.90078 14 7.48438 14C3.86133 14 0.921875 11.0633 0.921875 7.4375ZM15.3156 7.875C15.5699 7.875 15.7695 8.08828 15.7367 8.33984C15.5262 9.86836 14.7906 11.2273 13.716 12.2309C13.552 12.384 13.2949 12.373 13.1363 12.2117L8.79688 7.875H15.3156Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.bd3f32c05270e142f7f8833c2e834dfd.svg";
export { ForwardRef as ReactComponent };